import sourceTypes from "../../../constants/sourceTypes";

export default {
  sendContactAgentEvent: ({ expertsApiUuid, fromSource, saleId }) => {
    const labelParts = [saleId];

    if (expertsApiUuid) {
      labelParts.push(`uuid=${expertsApiUuid}`);
    }

    labelParts.push(`from=${fromSource}`);

    const eventLabel = labelParts.join("|");

    global.dataLayer.push({
      event: "custom_event",
      event_category: "resources_profiles",
      event_action: "contact",
      event_label: eventLabel
    });
  },
  sendClickToContactCTA: ({ fromSource }) => {
    global.dataLayer.push({
      event: "custom_event",
      event_action:
        fromSource === sourceTypes.expertHDP
          ? "building_expert_event"
          : "pa_box_interaction",
      event_category: "sales_show",
      event_label: "agent_profile"
    });
  }
};
